module.exports = __webpack_public_path__ + "img/kIn.f2be708d.png";